import axiosWithToken from "axiosWithToken";
import { UserDetails } from "./types";

const apiUrl = process.env.REACT_APP_API_URL;

export const getUserDetails = async (): Promise<UserDetails> => {
  try {
    const response = await axiosWithToken.get<UserDetails>(
      `${apiUrl}api/auth/user`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting account details:", error);
    throw error;
  }
};
